// B1.4: move-only from client.ts.
import { ApiClientCore, buildQueryString } from './http/core';

export class DocumentsApi extends ApiClientCore {
  async getDocuments(params: Record<string, any> = {}): Promise<any[]> {
    return this.get(`/api/v1/documents${buildQueryString(params)}`);
  }
  async getDocument(id: number): Promise<any> {
    return this.get(`/api/v1/documents/${id}`);
  }
  async getDocumentStats(): Promise<any> {
    return this.get('/api/v1/documents/stats');
  }
  async getExpiringDocuments(days = 30): Promise<any[]> {
    return this.get(`/api/v1/documents/expiring${buildQueryString({ days })}`);
  }
  async createDocument(data: any): Promise<any> {
    return this.post('/api/v1/documents', data);
  }
  async updateDocument(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/documents/${id}`, data);
  }
  async deleteDocument(id: number): Promise<any> {
    return this.delete(`/api/v1/documents/${id}`);
  }
  // ─── Breaks ──────────────────────────────────────────────────────────────────
}
